import React from 'react';

export type TableContextValue = {
  shouldVirtualize: boolean;
};

const defaultTableContextValue: TableContextValue = {
  shouldVirtualize: false,
};

const TableContext = React.createContext<TableContextValue>(defaultTableContextValue);

export function useTableContext(): TableContextValue {
  return React.useContext(TableContext);
}

export { TableContext };
